import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/dev-716-cannabis/components/shop/shop-nav-bar.tsx");
